module.exports = __webpack_public_path__ + "img/social-media-display-hyundai.f19af26d.png";